import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { dashboardGuard } from './guards/dashboard.guard';
import { settingsGuard } from './guards/settings.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    pathMatch: 'full',
  },
  {
    path: 'invite',
    loadComponent: () => import('./pages/invite/invite.component').then(m => m.InviteComponent)
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'health',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./layout/app-shell/app-shell.component').then(m => m.AppShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'business',
        canActivate: [dashboardGuard],
        loadComponent: () => import('./pages/business-metrics/business-metrics.component').then(m => m.BusinessMetricsComponent)
      },
      {
        path: 'game-design',
        canActivate: [dashboardGuard],
        loadComponent: () => import('./pages/game-design/game-design.component').then(m => m.GameDesignComponent)
      },
      {
        path: 'events',
        canActivate: [dashboardGuard],
        loadComponent: () => import('./pages/raw-events/raw-events.component').then(m => m.RawEventsComponent)
      },
      {
        path: 'machines',
        canActivate: [dashboardGuard],
        loadComponent: () => import('./pages/machines/machines.component').then(m => m.MachinesComponent)
      },
      {
        path: 'settings',
        canActivate: [settingsGuard],
        loadComponent: () => import('./pages/settings/settings.component').then(m => m.SettingsComponent)
      },
      {
        path: 'licenses',
        canActivate: [settingsGuard],
        loadComponent: () => import('./pages/licenses/licenses.component').then(m => m.LicensesComponent)
      },
    ]
  },
  { path: '**', redirectTo: '' }
];
